var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsZoomin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67114 6.37925C3.67114 5.91902 4.04424 5.54592 4.50448 5.54592H5.56283V4.49592C5.56283 4.03568 5.93592 3.66258 6.39616 3.66258C6.8564 3.66258 7.22949 4.03568 7.22949 4.49592V5.54592H8.27948C8.73971 5.54592 9.11281 5.91902 9.11281 6.37925C9.11281 6.83949 8.73971 7.21259 8.27948 7.21259H7.22949V8.27092C7.22949 8.73116 6.8564 9.10425 6.39616 9.10425C5.93592 9.10425 5.56283 8.73116 5.56283 8.27092V7.21259H4.50448C4.04424 7.21259 3.67114 6.83949 3.67114 6.37925Z",
    fill: "#1B3DF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6773 2.09858L10.6808 2.1021L10.6854 2.10667C12.854 4.2753 13.0358 7.67681 11.2309 10.0522L13.427 12.2483C13.7525 12.5738 13.7525 13.1014 13.427 13.4268C13.1016 13.7523 12.574 13.7523 12.2485 13.4268L10.0504 11.2287C7.6698 13.0261 4.27385 12.8438 2.10688 10.6768C-0.267495 8.30247 -0.269604 4.46651 2.10598 2.09839C4.47343 -0.277484 8.31031 -0.277105 10.6773 2.09858ZM3.28575 3.27564C5.00173 1.55266 7.78067 1.55266 9.49663 3.27493L9.50231 3.28058L9.50688 3.28518C11.2228 5.00115 11.2231 7.78126 9.50765 9.49755C7.78212 11.2156 5.00082 11.2138 3.28539 9.49833C1.56014 7.77308 1.56187 4.99323 3.28347 3.27792L3.28575 3.27564Z",
    fill: "#1B3DF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsZoomin);
export default __webpack_public_path__ + "static/media/icons-zoomin.883d8df2fb74989766556002ea6cc1d8.svg";
export { ForwardRef as ReactComponent };